export enum BookingsViewTypeEnum {
  Grid = "Grid",
  Calendar = "Calendar",
}
